import { createApp } from 'vue'
import App from './App.vue'
import Api from './common/api';
import Router from './router'
import ElementPlus from 'element-plus'
import VueTheMask from 'vue-the-mask'
import 'element-plus/lib/theme-chalk/index.css';

const app = createApp(App)
app.config.globalProperties.$api = Api;

let token = localStorage.getItem('token');
app.config.globalProperties.userToken = null;
if (token) {
    app.config.globalProperties.userToken = token;
}

Router.beforeEach((to, from, next) => {
    let auth = to.meta.auth;
    if (auth) {
        if (token) {
            next();
        } else {
            next({
                name: 'Login'
            });
        }
    }

    next();
});

app.use(Router);
app.use(ElementPlus);
app.use(VueTheMask)
app.mount('#app')